import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgxFormConfig } from './ngx-form.interfaces';
export class NgxFormComponent {
   form: FormGroup = new FormGroup({})
   config: NgxFormConfig
   item = {}
   action: EventEmitter<any> = new EventEmitter()
/**
 * @param {?} $event
 * @return {?}
 */
handleAction($event) {
    this.action.emit($event)
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ngx-form',
  template: `
    <form class="card" novalidate [formGroup]="form">
      <ngx-form-header class="card-header"
                       *ngIf="config.icon || config.title"
                       [icon]="config.icon" [title]="config.title" [item]="item">
      </ngx-form-header>
      <ngx-form-fields class="card-body"
                       *ngIf="config.fields"
                       [fields]="config.fields" [form]="form" [item]="item" (action)="handleAction($event)">
      </ngx-form-fields>
      <ngx-form-buttons class="card-footer"
                        *ngIf="config.buttons && config.buttons.length"
                        [buttons]="config.buttons" [item]="item" (action)="handleAction($event)">
      </ngx-form-buttons>
    </form>
  `,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'form': [{ type: Input },],
'config': [{ type: Input },],
'item': [{ type: Input },],
'action': [{ type: Output },],
};
}

function NgxFormComponent_tsickle_Closure_declarations() {
/** @type {?} */
NgxFormComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgxFormComponent.ctorParameters;
/** @type {?} */
NgxFormComponent.propDecorators;
/** @type {?} */
NgxFormComponent.prototype.form;
/** @type {?} */
NgxFormComponent.prototype.config;
/** @type {?} */
NgxFormComponent.prototype.item;
/** @type {?} */
NgxFormComponent.prototype.action;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
